import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {FieldOverrideConfiguration} from "./field-override-configuration";

@JsonObject()
export class StationFieldsConfiguration {
    /**
     * X coordinate field name
     */
    @JsonProperty()
    declare x: string;

    /**
     * Y coordinate filed name
     */
    @JsonProperty()
    declare y: string;

    /**
     * Object type field name
     */
    @JsonProperty()
    declare objectType: string;

    constructor() {}
}

@JsonObject()
export class FieldAggregationConfiguration {
    // field name
    @JsonProperty()
    declare fieldName: string;

    @JsonProperty()
    declare separator: string;

    @JsonProperty()
    declare sort: boolean;

    constructor() {}
}

@JsonObject()
export class SpecialismConfiguration {
    /**
     * departments to include
     */
    @JsonProperty()
    declare baseIds: object;

    /**
     * Mapping of baseIds and topic
     */
    @JsonProperty()
    declare topics: object;

    /**
     * ignorable departments
     */
    @JsonProperty()
    declare ignore: string[];

    constructor() {}
}

@JsonObject()
export class StationsConfiguration {

    /**
     * Specific fields in WISKI
     */
    @JsonProperty()
    declare fields: StationFieldsConfiguration;

    /**
     * Mapping fields to Station properties
     */
    @JsonProperty()
    declare fieldMappings: string[][];

    /**
     * Override field values
     */
    @JsonProperty()
    declare overrides: FieldOverrideConfiguration[];

    @JsonProperty()
    declare fieldAggregations: FieldAggregationConfiguration[];

    @JsonProperty()
    declare objectTypes: SpecialismConfiguration;

    /**
     * Mappings to resolve different values for parameter type
     * Legt fest, welche Parameter auf welchen Stationstypen gemessen werden.
     * Dient dazu, herauszufinden, auf welchen Stationen Messwerte gespeichert werden müssen.
     */
    @JsonProperty()
    declare parameterTypeObjectTypeIdMappings: {[key: string]: any};

    /**
     * Mappings to map parameterType to measurement fields in feature class model
     */
    @JsonProperty()
    declare stationParameterMeasurementFieldMappings: {[key: string]: any};

    /**
     * Expression for calculating a 'measurementCode' based on measurements
     * measurementCode can be used for symbolizing features on a map
     */
    @JsonProperty()
    declare measurementCodeExpression: {[key: string]: any};

    constructor() {}
}
